import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LoginSessionState, SessionTimerServiceService } from '../../core/auth/session-timer-service.service';
declare let $: any;

@Component({
  selector: 'hb-modal-dialog',
  templateUrl: './modal-dialog.component.html',
  styleUrls: ['./modal-dialog.component.scss'],
})
export class ModalDialogComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() heading: string;
  @Input() subHeading: string;
  @Input() okBtnId: string;
  @Input() okDisabled: boolean = false;
  @Input() showCancel: boolean = true;
  @Input() showFooter: boolean = true;
  @Input() restrictHeight: boolean = true;
  @Input() noOverflow: boolean = false;

  hideOptionalFooter: boolean = false;
  private unsubscribe: Subject<boolean> = new Subject();

  @Output() okClicked = new EventEmitter<Event>();

  @ViewChild('optionalFooter', { static: true }) optionalFooter;

  constructor(
    public bsModalRef: BsModalRef,
    private timeoutService: SessionTimerServiceService,
  ) { }

  ngOnInit() {
    this.timeoutService.loginSessionStateChanged.pipe(
      takeUntil(this.unsubscribe))
      .subscribe(state => {
        if (state === LoginSessionState.NotLoggedIn) {
          this.close();
        }
      });
    this.hideOptionalFooter = !(this.optionalFooter.nativeElement.children.length > 0);
  }

  ngAfterViewInit() {
    $('.modal-content').draggable({
      handle: '.modal-header',
      containment: 'document',
    });
  }

  ngOnDestroy() {
    this.unsubscribe.next(true);
    this.unsubscribe.complete();
  }

  close() {
    this.bsModalRef.hide();
  }

  okClick(event: Event) {
    this.okClicked.emit(event);

    if (event.defaultPrevented) {
      return;
    }

    this.close();
  }
}
